/* eslint-disable react/display-name */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getToken } from "utils/getToken";

const withAuth = (WrappedComponent) => {
  return (props) => {
    const navigate = useNavigate();

    const stringifyToken = getToken();
    // const parsedToken = stringifyToken ? JSON.parse(stringifyToken) : null;

    useEffect(() => {
      if (!stringifyToken) {
        navigate("/");
      }
    }, [stringifyToken]);

    return <WrappedComponent {...props} />;
  };
};

export default withAuth;
